import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BoardComponent } from './board/board.component';
import { RootComponent } from './root/root.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', component:RootComponent},
    { path: 'board',component:BoardComponent } ,
    { path: '**', component:RootComponent } ]
@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { 


}
